var map = {
	"./ad_pptbaike.png": 105,
	"./bg_buy_one.png": 126,
	"./bg_customer.png": 175,
	"./bg_customer_content.png": 7920,
	"./bg_customer_line.png": 5135,
	"./bg_customer_line2.png": 8426,
	"./bg_exchange_success.png": 5254,
	"./bg_exchange_success_line.png": 6663,
	"./bg_home_banner.png": 2353,
	"./bg_home_banner1.png": 8162,
	"./bg_home_banner2.png": 8907,
	"./bg_home_banner4.png": 5006,
	"./bg_home_banner_title.png": 9743,
	"./bg_pay_success.png": 654,
	"./buy_one_server_qr.png": 580,
	"./buy_vip_server_qr.png": 812,
	"./category/1.png": 4635,
	"./category/2.png": 1466,
	"./category/3.png": 7390,
	"./category/4.png": 9284,
	"./category/5.png": 4997,
	"./category/6.png": 7054,
	"./category/7.png": 4675,
	"./category/8.png": 8960,
	"./custom_made_wxqr.png": 5905,
	"./customer_wxqr.png": 1381,
	"./detail/bg_check.png": 8570,
	"./detail/icon_down.png": 8955,
	"./detail/icon_last.png": 2420,
	"./detail/icon_next.png": 3730,
	"./detail/icon_play-video.png": 9739,
	"./detail/icon_share.png": 8617,
	"./detail/icon_star.png": 1866,
	"./detail/icon_vip-free.png": 4857,
	"./detail/icon_vip.png": 9078,
	"./home-page/logo.png": 6371,
	"./icon_alipay.png": 3780,
	"./icon_alipay_1.png": 1219,
	"./icon_avatar.png": 704,
	"./icon_check.png": 4170,
	"./icon_check1.png": 4315,
	"./icon_close.png": 4461,
	"./icon_custom_made.png": 8351,
	"./icon_customer_check.png": 3589,
	"./icon_customer_logo.png": 6041,
	"./icon_customer_service.png": 8018,
	"./icon_customer_star.png": 7663,
	"./icon_exchange_code.png": 3829,
	"./icon_lihua.png": 5642,
	"./icon_lock.png": 2975,
	"./icon_logo.png": 999,
	"./icon_open_vip.png": 7948,
	"./icon_pay_success.png": 2036,
	"./icon_pc.png": 1850,
	"./icon_search.png": 9673,
	"./icon_search2.png": 2529,
	"./icon_wepay.png": 8574,
	"./icon_wepay_1.png": 2669,
	"./icon_wepay_2.png": 9276,
	"./icon_wexin.png": 2443,
	"./new-user/bg_float.png": 222,
	"./new-user/bg_float1.png": 6022,
	"./new-user/bg_float_content.png": 9772,
	"./new-user/bg_float_content_line.png": 4507,
	"./new-user/bg_float_title.png": 6698,
	"./new-user/bg_new_user.png": 6759,
	"./new-user/customer_wxqr.png": 8291,
	"./new-user/icon_move.png": 8359,
	"./new-user/icon_star.png": 9689,
	"./new-user/lihua.png": 2482,
	"./new-user/star.png": 2906,
	"./new-user/star1.png": 6344,
	"./new-user/star2.png": 9110,
	"./new-user/title.png": 6498,
	"./new-user/top-right-bg.png": 6294,
	"./open-vip/bg_goods.png": 2919,
	"./open-vip/bg_line_light.png": 6390,
	"./open-vip/bg_modal.png": 1263,
	"./open-vip/icon_benefits.png": 3218,
	"./open-vip/icon_benefits_1.png": 6544,
	"./open-vip/icon_benefits_2.png": 482,
	"./open-vip/icon_benefits_3.png": 4500,
	"./open-vip/icon_benefits_4.png": 3360,
	"./open-vip/icon_benefits_5.png": 3364,
	"./open-vip/icon_benefits_6.png": 3660,
	"./open-vip/icon_check.png": 6375,
	"./open-vip/icon_double_quote.png": 9782,
	"./open-vip/icon_double_quote_2.png": 4138,
	"./open-vip/icon_search.png": 6356,
	"./open-vip/icon_star.png": 5173,
	"./open-vip/icon_star_2.png": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;